import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";
import { subDays } from "date-fns";


// Async thunk for fetching pickup addresses
export const fetchDashboardData = createAsyncThunk(
    "dashboard/fetch",
    async (data = { startDate: subDays(new Date(), 30), endDate: new Date() }, { rejectWithValue }) => {
        try {
            // Call the API to fetch pickup addresses
            const response = await request({
                endpoint: "/user/dashboard", // Replace with your actual endpoint
                method: "GET",
                params: data,
            });

            console.log("Fetch DashboardData Response:", response);

            // Check if the fetch operation was successful
            if (!response.success) {
                return rejectWithValue(response.message || "Failed to fetch dashboard data.");
            }

            // Return the fetched pickup addresses
            return response.data; // Assuming the response contains an array of addresses in `data`
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            return rejectWithValue(error.error.code || "An unexpected error occurred while fetching Dashboard data.");
        }
    }
);

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Pickup Addresses
            .addCase(fetchDashboardData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDashboardData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload; // Update the data
                state.pickupAddresses = action.payload; // Update the pickup addresses array
            })
            .addCase(fetchDashboardData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            });
    },
});

export const { } = dashboardSlice.actions;
export default dashboardSlice.reducer;